import React, { useState } from 'react';
import { Input, Button, Form } from 'reactstrap';
import SearchService from '../../services/search';
import { useHistory } from 'react-router-dom';
import toastNotification from '../../components/Notifications/toastNotification';

const SearchBar = () => {
    const [searchText, setSearchText] = useState('');
    const [searchResult, setSearchResult] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const history = useHistory();

    const onSubmit = async (e) => {
        e.preventDefault();
        if (searchText && searchText.length >= 2) {
            try {
                const result = await SearchService.search(searchText);
                setSearchResult(result);
                setShowDropdown(true);
            } catch (e) {
                setSearchResult([]);
                setShowDropdown(false);
                toastNotification('error', 'Fel i sökning');
            }
        }
    };

    const handleResultClick = async (item) => {
        try {
            let mappedType = item.objecttype;
            if (mappedType === 'School_Type__c') mappedType = 'schooltype';
            else if (mappedType === 'Subject__c') mappedType = 'subject';
            else if (mappedType === 'Course__c') mappedType = 'course';
            else if (mappedType === 'Course_Content__c') mappedType = 'coursecontent';
            else if (mappedType === 'Lesson__c') mappedType = 'lesson';
            else if (mappedType === 'Assignment__c') mappedType = 'assignment';

            const result = await SearchService.getPath(item.Id, mappedType);
            //console.log('Path result:', result);

            if (!Array.isArray(result) || result.length === 0 || !result[0].linkPath) {
                console.error('No valid linkPath found in search result:', result);
                toastNotification('error', 'Kunde inte hitta en länk för sökträffen.');
                return;
            }

            let path;
            if (
                mappedType === 'subject' ||
                mappedType === 'course' ||
                (mappedType === 'schooltype' &&
                    !['vuxenutbildning', 'folkhogskola', 'gymnasieskola', 'grundskola'].includes(result[0].linkPath))
            ) {
                path = '/' + result[0].coursecontentPath;
                //console.log('Navigating to coursecontentPath:', path);
            } else {
                path = '/' + result[0].linkPath;
                //console.log('Navigating to linkPath:', path);
            }

            if (!path || path === '/') {
                toastNotification('error', 'Kunde inte hitta en länk för sökträffen (2).');
                return;
            }

            history.push(path);
            setShowDropdown(false);
        } catch (e) {
            toastNotification('error', 'Kunde inte hitta en länk för sökträffen (3).');
        }
    };

    const handleInputChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleBlur = () => {
        setTimeout(() => setShowDropdown(false), 150);
    };

    const getIconForObjectType = (objecttype, type = null) => {
        switch (objecttype) {
            case 'School_Type__c':
                return <i className="pe-7s-home text-muted fsize-1" />;
            case 'Subject__c':
                return <i className="pe-7s-bookmarks text-muted fsize-1" />;
            case 'Course__c':
                return <i className="pe-7s-notebook text-muted fsize-1" />;
            case 'Course_Content__c':
                return <i className="pe-7s-folder text-muted fsize-1" />;
            case 'Lesson__c':
                return <i className="pe-7s-note text-muted fsize-1" />;
            case 'Assignment__c':
                if (type === 'video') return <i className="pe-7s-film text-muted fsize-1" />;
                if (type === 'pdf') return <i className="pe-7s-file text-muted fsize-1" />;
                if (type === 'formlink') return <i className="pe-7s-note2 text-muted fsize-1" />;
                return <i className="pe-7s-paperclip text-muted fsize-1" />;
            default:
                return <i className="pe-7s-help1 text-muted fsize-1" />;
        }
    };
    //console.log('searchResult', searchResult)
    return (
        <div style={{ position: 'relative', minWidth: 200, margin: '0 1rem' }}>
            <Form inline onSubmit={onSubmit} autoComplete="off" style={{ display: 'flex', alignItems: 'center' }}>
                <Input
                    type="text"
                    name="search"
                    value={searchText}
                    onChange={handleInputChange}
                    onFocus={() => searchResult.length > 0 && setShowDropdown(true)}
                    onBlur={handleBlur}
                    placeholder="Sök..."
                    style={{
                        fontSize: 14,
                        padding: '2px 8px',
                        height: 32,
                        width: 150,
                        border: '1px solid #ddd',
                        borderRadius: 4,
                    }}
                />
                <Button
                    color="light"
                    size="sm"
                    type="submit"
                    title="Sök efter innehåll" // Tooltip med texten "Sök efter innehåll"
                    style={{
                        marginLeft: 4,
                        height: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 8px',
                        backgroundColor: '#f8f9fa', // Ljusare ton
                        border: '1px solid #ddd', // Matchar inputfältet
                        borderRadius: 4,
                        color: '#495057', // Textfärg
                        boxShadow: 'none', // Ingen skugga
                    }}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = '#e9ecef')} // Hover-effekt
                    onMouseLeave={(e) => (e.target.style.backgroundColor = '#f8f9fa')} // Återställ vid hover
                >
                    <i className="pe-7s-search" style={{ fontSize: 16 }} /> {/* Sökikon */}
                </Button>
            </Form>
            {showDropdown && searchResult.length > 0 && (
                <div
                    style={{
                        position: 'absolute',
                        top: 36,
                        left: 0,
                        right: 0,
                        background: '#fff',
                        border: '1px solid #ddd',
                        borderRadius: 4,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        zIndex: 1000,
                        maxHeight: 300,
                        overflowY: 'auto',
                    }}
                >
                    {searchResult.slice(0, 12).map(item => {
                        // Map objecttype and Type__c to human-readable labels
                        const getTypeLabel = (objecttype, type = null) => {
                            switch (objecttype) {
                                case 'School_Type__c': return 'Skoltyp';
                                case 'Subject__c': return 'Ämne';
                                case 'Course__c': return 'Kurs';
                                case 'Course_Content__c': return 'Kursområde';
                                case 'Lesson__c': return 'Lektion';
                                case 'Assignment__c':
                                    if (type === 'video') return 'Video';
                                    if (type === 'pdf') return 'Pdf';
                                    if (type === 'formlink') return 'Formulär';
                                    return 'Uppgift';
                                default: return 'Okänd typ';
                            }
                        };

                        const typeLabel = getTypeLabel(item.objecttype, item.Type__c);

                        return (
                            <div
                                key={item.Id}
                                style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    padding: '8px 12px',
                                    cursor: 'pointer',
                                    overflow: 'hidden',
                                }}
                                onMouseDown={() => handleResultClick(item)}
                                title={`${typeLabel}: ${item.Name}${item.Description__c ? ` - ${item.Description__c}` : ''}`} // Tooltip with type, name, and description
                            >
                                <div style={{ marginRight: 8, flexShrink: 0 }}>
                                    {getIconForObjectType(item.objecttype, item.Type__c)}
                                </div>
                                <div style={{ flex: 1, overflow: 'hidden' }}>
                                    <strong
                                        style={{
                                            display: 'block',
                                            whiteSpace: 'normal', // Allow wrapping
                                            overflow: 'hidden',
                                            maxHeight: '2.4em', // Limit to 2 lines
                                            lineHeight: '1.2em',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {item.Name}
                                    </strong>
                                    {item.Description__c && (
                                        <div
                                            style={{
                                                color: '#888',
                                                fontSize: 12,
                                                marginTop: 4,
                                                whiteSpace: 'nowrap', // Allow wrapping
                                                overflow: 'hidden',
                                                maxHeight: '3.6em', // Limit to 3 lines
                                                lineHeight: '1.2em',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {item.Description__c}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                    {searchResult.length > 8 && (
                        <div
                            style={{
                                padding: '8px 12px',
                                borderTop: '1px solid #eee',
                                background: '#f9f9f9',
                                fontWeight: 500,
                                fontSize: 13,
                                color: '#888', // Make it visually distinct
                            }}
                        >
                            Prova att använda fler sökord för att begränsa sökningen.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default SearchBar;